import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { List, X } from "@phosphor-icons/react";

const LINKS = [
  { label: "Services", href: "#services" },
  { label: "Method", href: "#method" },
  { label: "About", href: "#about" },
  { label: "FAQ", href: "#faq" },
];

export const BrandMark = ({ compact = false }) => (
  <div className="flex items-center gap-3">
    <div className={`${compact ? "w-9 h-9" : "w-11 h-11"} rounded-full bg-white p-1 flex items-center justify-center shadow-[0_0_20px_rgba(212,175,55,0.25)]`}>
      <img src="/logo-mark.png" alt="Claimspace LegalTech logo" className="w-full h-full object-contain" />
    </div>
    <div className="leading-none">
      <span className={`block font-serif font-semibold tracking-wide text-white ${compact ? "text-base" : "text-lg"}`}>CLAIMSPACE</span>
      <span className="block text-[10px] tracking-[0.4em] text-gold mt-1">LEGALTECH</span>
    </div>
  </div>
);

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  const base = pathname === "/" ? "" : "/";

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header data-testid="main-navbar" className={`fixed top-0 inset-x-0 z-50 transition-[background-color,border-color] duration-500 ${scrolled || pathname !== "/" ? "backdrop-blur-2xl bg-navy-950/80 border-b border-white/10" : "bg-transparent"}`}>
      <div className="max-w-7xl mx-auto px-6 sm:px-8 h-20 flex items-center justify-between">
        <Link to="/" data-testid="nav-brand-link"><BrandMark /></Link>
        <nav className="hidden lg:flex items-center gap-10">
          {LINKS.map((l) => (
            <a key={l.href} href={`${base}${l.href}`} data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="text-sm text-mist hover:text-gold transition-colors duration-300 tracking-wide">
              {l.label}
            </a>
          ))}
        </nav>
        <div className="hidden lg:flex items-center gap-4">
          <a href={`${base}#contact`} data-testid="nav-quote-button"
            className="text-sm px-6 py-2.5 border border-gold/60 text-gold hover:bg-gold hover:text-navy-950 transition-colors duration-300 tracking-wide">
            Request a Quote
          </a>
          <Link to="/portal/login" data-testid="nav-portal-button"
            className="text-sm px-6 py-2.5 bg-gold text-navy-950 font-semibold hover:bg-gold-light transition-colors duration-300 tracking-wide">
            Client Portal
          </Link>
        </div>
        <button data-testid="nav-mobile-toggle" className="lg:hidden text-white" onClick={() => setOpen(!open)} aria-label="Menu">
          {open ? <X size={26} /> : <List size={26} />}
        </button>
      </div>
      {open && (
        <div className="lg:hidden bg-navy-950/95 backdrop-blur-2xl border-t border-white/10 px-6 py-6 flex flex-col gap-5">
          {LINKS.map((l) => (
            <a key={l.href} href={`${base}${l.href}`} data-testid={`nav-mobile-link-${l.label.toLowerCase()}`} onClick={() => setOpen(false)}
              className="text-mist hover:text-gold transition-colors">{l.label}</a>
          ))}
          <Link to="/portal/login" data-testid="nav-mobile-portal-button" className="text-gold font-semibold">Client Portal</Link>
        </div>
      )}
    </header>
  );
}
